import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { NavLink } from "react-router-dom";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import YoutubeIcon from "@material-ui/icons/YouTube";
import Facebook from "@material-ui/icons/Facebook";
import Footer from "../Footer/Footer";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  strikeThrough: {
    textDecoration: "line-through",
    color: "white",
  },
  title: {
    color: "white",
  },
}));

export default function MenuAppBar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();
  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
  const checkActive = (match, location) => {
    if (!location) return false;
    const { pathname } = location;
    return pathname === "/";
  };
  const handleClick = (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const theList = [
    {
      title: "Trang chủ",
      path: "/",
      checkActive: checkActive,
    },
    {
      title: "Thực đơn",
      path: "/menu",
      checkActive: null,
    },
    {
      title: "Về chúng tôi",
      path: "/about",
      checkActive: null,
    },
    {
      title: "Liên hệ",
      path: "/contact",
      checkActive: null,
    },
  ];
  const list = () => (
    <div
      role="presentation"
      onClick={handleClick}
      onKeyDown={handleClick}
      style={{
        background: "linear-gradient(270deg, #E7A977, #EBBE9B)",
        backgroundSize: "400% 400%",
        WebkitAnimation: "breath 3s ease infinite",
        MozAnimation: "breath 3s ease infinite",
        animation: "breath 3s ease infinite",
      }}
    >
      <List>
        {theList.map((text) => (
          <NavLink
            to={text.path}
            isActive={text.checkActive}
            activeClassName={classes.strikeThrough}
            className={classes.title}
          >
            <ListItem button key={text}>
              {text.title}
            </ListItem>
          </NavLink>
        ))}
      </List>
      <Divider></Divider>
      <List>
        <ListItem>
          <IconButton
            href="https://www.facebook.com/bunbapboonhu"
            target="_blank"
            rel="noreferrer"
          >
            <Facebook
              fontSize="large"
              style={{
                color: "#996f32",
              }}
            />
          </IconButton>
          {/* <IconButton>
            <YoutubeIcon
              fontSize="large"
              style={{
                color: "#996f32",
              }}
            />
          </IconButton> */}
        </ListItem>
        <Divider></Divider>
        <Footer />
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        style={{
          backgroundColor: "transparent",
        }}
        elevation="0"
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleClick}
          >
            <MenuIcon />
          </IconButton>
          <SwipeableDrawer
            variant="persistant"
            disableBackdropTransition={!iOS}
            disableDiscovery={iOS}
            open={anchorEl}
            anchor="top"
            onClose={handleClose}
            onOpen={handleClick}
          >
            {list()}
          </SwipeableDrawer>
        </Toolbar>
      </AppBar>
    </div>
  );
}
